import {actions as A} from '../constants/actions';

export const setTokens = tokens => dispatch => (
  dispatch({
    type: A.LOGIN_SUCCESS,
    payload: {tokens}
  })
);

